export function getAutocorrectInsertion(text: string, before: string, after: string): string {
  const value = text.trim();

  if (!value) {
    return '';
  }

  const prefix = before && !/\s$/.test(before) ? ' ' : '';
  const suffix = !after || !/^\s/.test(after) ? ' ' : '';

  return prefix + value + suffix;
}
